import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApolloError } from '@apollo/client';
import { getAuth } from 'firebase/auth';

export function useAuthErrorHandler(error: ApolloError | undefined) {
  const navigate = useNavigate();

  useEffect(() => {
    if (error && error.graphQLErrors) {
      const hasAuthError = error.graphQLErrors.some(err => err.extensions?.code === 'UNAUTHENTICATED');
      
      if (hasAuthError) {
        console.log('Authentication error detected in hook, signing out and redirecting to login');
        
        // Sign out from Firebase to clear the invalid token
        const auth = getAuth();
        auth.signOut()
          .then(() => {
            console.log('Signed out user due to authentication error');
            navigate('/auth');
          })
          .catch((signOutError) => {
            console.error('Error signing out:', signOutError);
            // Navigate to auth page anyway
            navigate('/auth');
          });
        
        return;
      }
    }
  }, [error, navigate]);
}